import { INameValue } from 'src/app/common/interfaces/name-value-interface';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import { IRejectAnalysisTransactionDetail } from '../../interfaces/reject-analysis/reject-analysis-transaction-detail.interface';
import { IRejectAnalysisTransactionDetailsRequest } from '../../interfaces/reject-analysis/reject-analysis-transaction-details-request.interface';

export abstract class AbstractRejectAnalysisService extends ITableService {
  abstract getDetailsForRow(dataKey: string): Promise<any[]>;
  abstract getRejectCodeOptions(): Promise<INameValue[]>;
  /** Reject code options derived from the most recently loaded grid data; empty when none loaded. */
  abstract getLoadedRejectCodeOptions(): INameValue[];
  abstract getRespondentOptions(): Promise<INameValue[]>;
  abstract getById(messageId: string, type: string, primaryRtn: string): Promise<any>;
  abstract getReturnById(messageId: string, type: string, primaryRtn: string): Promise<any>;
  abstract getTransactionDetails(
    request: IRejectAnalysisTransactionDetailsRequest
  ): Promise<ITableServerResponseFilter | undefined>;
}
